import styled, { css } from 'styled-components';

import { INavBarProps, NavBarOrientation } from './NavBar.types';

const NavBar = styled.header<Required<Pick<INavBarProps, 'orientation' | 'float'>>>`
  display: flex;
  flex-wrap: nowrap;

  ${({ orientation, float, theme }) => css`
    flex-direction: ${orientation === 'horizontal' ? 'row' : 'column'};
    box-shadow: ${float ? theme.elevation.level1 : null};
    height: ${orientation === 'vertical' ? '100%' : 'auto'};
    width: ${orientation === 'vertical' ? 'max-content' : '100%'};
  `}
`;

const MiddleArea = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  overflow: overlay;
`;

function getAreaMargin(orientation: NavBarOrientation, number: number): string {
  if (orientation === 'horizontal') {
    return number === 1 ? '0 16px 0 0' : '0 0 0 16px';
  }

  return number === 1 ? '0 0 16px 0' : '16px 0 0 0';
}

const Area = styled.div<{ orientation: NavBarOrientation; number: 1 | 3 }>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ orientation, number }) => css`
    margin: ${getAreaMargin(orientation, number)};
  `}
`;

export { NavBar, MiddleArea, Area };
